export function removeDuplicateItems<T>(arr: Array<T>, key: string) {
  return arr.filter((v: any, i, a) => a.findIndex((v2: any) => (v2[key] === v[key])) === i) as unknown as Array<T>;
}
